import React, { useState, useEffect } from "react";
import Footer from "apollo-react/components/Footer";
import Modal from "apollo-react/components/Modal";
import Typography from "apollo-react/components/Typography";
import "./Footer.scss";
import PrivacyContent from "./PrivacyContent";
import TermsContent from "./TermsContent";
import IQVIALogo from "./IQVIALogo";

interface CustomFooterProps {
  isSidebarCollapsed?: boolean;
  getContentMarginLeft?: () => string;
}

const CustomFooter: React.FC<CustomFooterProps> = ({
  isSidebarCollapsed = false,
  getContentMarginLeft,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<"privacy" | "terms" | null>(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
  }, []);

  const handleOpenModal = (type: "privacy" | "terms") => {
    setModalType(type);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalType(null);
  };

  // Responsive button labels
  const getButtonProps = () => [
    {
      label: (
        <div style={{ display: "block" }}>
          {isMobile ? "Terms" : "Terms of Use"}
        </div>
      ),
      onClick: () => handleOpenModal("terms"),
    },
    {
      label: (
        <div style={{ display: "block" }}>
          {isMobile ? "Privacy" : "Privacy Policy"}
        </div>
      ),
      onClick: () => handleOpenModal("privacy"),
    },

    {
      label: (
        <div style={{ display: "block" }}>
          {isMobile ? "Contact" : "Contact Us"}
        </div>
      ),
      href: "https://www.iqvia.com/",
      target: "_blank",
    },
  ];

  return (
    <div
      className="footer-container sticky-footer"
      style={{
        marginLeft: "0px",
        transition: "margin-left 0.3s ease",
      }}
    >
      <Footer
        buttonProps={getButtonProps()}
        maxWidth={isMobile ? "100%" : 1600}
        style={{
          padding: isMobile ? "0.5rem 0.25rem" : "0.5rem 1rem",
          minHeight: isMobile ? "15px" : "40px",
          fontSize: isMobile ? "12px" : "14px",
        }}
      />
      <Modal
        open={showModal && !!modalType}
        onClose={handleCloseModal}
        title={<IQVIALogo />}
        subtitle={
          <Typography variant="h6" emphasis="high">
            {modalType === "privacy"
              ? "Privacy Statement"
              : modalType === "terms"
              ? "Terms of Use"
              : ""}
          </Typography>
        }
        hideButtons={true}
      >
        <div>
          {modalType === "privacy" && <PrivacyContent />}
          {modalType === "terms" && <TermsContent />}
        </div>
      </Modal>
    </div>
  );
};

export default CustomFooter;
